import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { Metadata} from "../models/metadata";
import { MetadataService } from "../services/metadata.service";
import { Observable } from "rxjs";

@Injectable()
export class MetadatasResolver implements Resolve<Metadata[]> {
    constructor(private metadataService: MetadataService) {
    }
    resolve(route: ActivatedRouteSnapshot): Observable<Metadata[]> {
        return this.metadataService.getAllMetadata();
    }
}
